import { AdvancedMarker } from "@vis.gl/react-google-maps";
import SpotlightMarker from "../../../../images/Spotlight Marker.svg";

interface Props {
  searchCoordinates: string;
}

const CoordinatesSearch = ({ searchCoordinates }: Props) => {
  if (searchCoordinates) {
    const parts = searchCoordinates.split(",").map(Number);

    if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
      return (
        <>
          {searchCoordinates && (
            <AdvancedMarker
              position={{
                lat: parts[0],
                lng: parts[1],
              }}
              zIndex={12}
            >
              <img src={SpotlightMarker} alt="Image not found" />
            </AdvancedMarker>
          )}
        </>
      );
    } else {
      console.warn("Invalid Coordinates format:", searchCoordinates);
    }
  }
};

export default CoordinatesSearch;